import { render } from "./AppSkeletonCaseView.vue?vue&type=template&id=fff9f3cc&scoped=true&ts=true"
import script from "./AppSkeletonCaseView.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonCaseView.vue?vue&type=script&lang=ts"

import "./AppSkeletonCaseView.vue?vue&type=style&index=0&id=fff9f3cc&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff9f3cc"]])

export default __exports__